import AdminPage from "components/pages/Admin/Index";
import { GetServerSidePropsContext } from "next";
import { NextPage } from "next";
import { getServerSession } from "next-auth";
import { authOptions } from "pages/api/auth/[...nextauth]";

interface Props {
  isAdminUser: boolean;
}

const DiscussAdmin: NextPage<Props> = ({ isAdminUser }) => {
  if (isAdminUser) {
    return <AdminPage />;
  } else
    return (
      <div className="flex w-screen h-screen items-center justify-center bg-white">
        <span className="whitespace-pre-line text-center text-[18px]">
          {`GNE 계정으로 로그인 후 접속해주세요.`}
        </span>
      </div>
    );
};
export default DiscussAdmin;

export async function getServerSideProps({
  locale,
  req,
  res,
}: GetServerSidePropsContext) {
  const session: any = await getServerSession(req, res, authOptions);

  // 현재 도메인 확인
  const currentDomain = req.headers.host || "";

  let isAdminUser = false;
  if (
    (session?.user?.email &&
      (session?.user?.email.includes("@juroinstruments.com") ||
        session?.user?.email.includes("@gne.ai")) &&
      currentDomain.includes("test.riskweather.io")) ||
    (process.env.NODE_ENV === "development" &&
      session?.user?.email.includes("@juroinstruments.com"))
  ) {
    isAdminUser = true;
  }

  return {
    props: {
      isAdminUser,
    },
  };
}
